import { useInjection } from "@linkfluence/core/di";
import { useMutation } from "@tanstack/react-query";
import {
  InsightPage,
  InsightPageSnapshotFactory,
} from "@radarly/models/insight-pages/model";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useSendSnapshot() {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const { mutateAsync, isLoading, isError, isSuccess, reset, data } =
    useMutation(
      ({
        project,
        id,
        snapshot,
      }: {
        project: number;
        id: InsightPage["id"];
        snapshot: InsightPageSnapshotFactory;
      }) => {
        return repository.sendSnapshot(project, id, snapshot);
      }
    );
  const sendSnapshot = (data: {
    project: number;
    id: InsightPage["id"];
    snapshot: InsightPageSnapshotFactory;
  }) => {
    return mutateAsync(data);
  };
  return {
    sendSnapshot,
    loading: isLoading,
    error: isError,
    success: isSuccess,
    snapshotUid: data ? data.s3Id : "",
    reset: () => reset(),
  };
}
